<form [formGroup]="businessForm" class="business-form">
  <div class="form-grid">
    <div class="form-group business-name-group">
      <label for="businessName" class="required">Business Name</label>
      <input
        id="businessName"
        type="text"
        formControlName="businessName"
        placeholder="Enter business name"
        autocomplete="off"
      />
      @if (
        businessForm.get("businessName")?.touched &&
        businessForm.get("businessName")?.invalid
      ) {
        <span class="error-message">Business name is required</span>
      }

      @if (activeDuplicateField === "businessName") {
        <ng-container
          *ngTemplateOutlet="duplicateResultsTemplate"
        ></ng-container>
      }
    </div>
    <div class="form-group">
      <label for="address" class="required">Address</label>
      <input id="address" type="text" formControlName="address" />
      @if (
        businessForm.get("address")?.touched &&
        businessForm.get("address")?.invalid
      ) {
        <span class="error-message">Address is required</span>
      }
    </div>
    <div class="form-group">
      <label for="stateOrProvince" class="required">State</label>
      <select id="stateOrProvince" formControlName="stateOrProvince">
        <option value="">Select a state</option>

        @for (state of states; track state.id) {
          <option [value]="state.name">{{ state.name }}</option>
        }
      </select>

      @if (
        businessForm.get("stateOrProvince")?.touched &&
        businessForm.get("stateOrProvince")?.invalid
      ) {
        <span class="error-message">State is required</span>
      }
    </div>

    <div class="form-group">
      <label for="county" class="required">County</label>
      <select
        id="county"
        formControlName="county"
        [disabled]="!businessForm.get('stateOrProvince')?.value"
      >
        <option value="">Select a county</option>

        @for (county of counties; track county.id) {
          <option [value]="county.name">{{ county.name }}</option>
        }
      </select>

      @if (!businessForm.get("stateOrProvince")?.value) {
        <span class="info-message">Please select a state first</span>
      }

      @if (
        businessForm.get("county")?.touched &&
        businessForm.get("county")?.invalid
      ) {
        <span class="error-message">County is required</span>
      }
    </div>

    <div class="form-group">
      <label for="city" class="required">City</label>
      <select
        id="city"
        formControlName="city"
        [disabled]="!businessForm.get('county')?.value"
      >
        <option value="">Select a city</option>

        @for (city of cities; track city.id) {
          <option [value]="city.name">{{ formatCityName(city.name) }}</option>
        }
      </select>

      @if (!businessForm.get("stateOrProvince")?.value) {
        <span class="info-message">Please select a state first</span>
      }

      @if (
        businessForm.get("city")?.touched && businessForm.get("city")?.invalid
      ) {
        <span class="error-message">City is required</span>
      }
    </div>

    <div class="form-group">
      <label for="zipCode" class="required">Zip Code</label>
      <select
        id="zipCode"
        formControlName="zipCode"
        [disabled]="!businessForm.get('city')?.value"
      >
        <option value="">Select zip code</option>

        @for (zip of zipcodes; track zip.id) {
          <option [value]="zip.code">{{ zip.code }}</option>
        }
      </select>

      @if (!businessForm.get("city")?.value) {
        <span class="info-message">Please select a city first</span>
      }

      @if (
        businessForm.get("zipCode")?.touched &&
        businessForm.get("zipCode")?.invalid
      ) {
        <span class="error-message">Zip code is required</span>
      }
    </div>
    <div class="form-group">
      <label for="country" class="required">Country</label>
      <input
        id="country"
        type="text"
        formControlName="country"
        value="United States"
        readonly
      />
      @if (
        businessForm.get("country")?.touched &&
        businessForm.get("country")?.invalid
      ) {
        <span class="error-message">Country is required</span>
      }
    </div>

    <div class="form-group">
      <label for="businessOwnerName" class="required"
        >Business Owner Name</label
      >
      <input
        id="businessOwnerName"
        type="text"
        formControlName="businessOwnerName"
        placeholder="Enter owner name"
      />
      @if (
        businessForm.get("businessOwnerName")?.touched &&
        businessForm.get("businessOwnerName")?.invalid
      ) {
        <span class="error-message">Business owner name is required</span>
      }
    </div>
    <div class="form-group">
      <label for="phone">Phone</label>
      <input
        id="phone"
        type="tel"
        formControlName="phone"
        placeholder="(123) 456-7890"
        maxlength="20"
      />
      @if (
        businessForm.get("phone")?.touched && businessForm.get("phone")?.invalid
      ) {
        @if (businessForm.get("phone")?.errors?.["pattern"]) {
          <span class="error-message">Please enter a valid phone number</span>
        }
      }
    </div>
    <div
      class="form-group email-group"
      [class.has-duplicate-card]="
        (isSearchingDuplicates || duplicateBusinesses.length > 0) &&
        activeDuplicateField === 'companyEmail'
      "
    >
      <label for="companyEmail" class="required">Email</label>
      <input
        id="companyEmail"
        type="email"
        formControlName="companyEmail"
        placeholder="example@domain.com"
      />
      @if (
        businessForm.get("companyEmail")?.touched &&
        businessForm.get("companyEmail")?.invalid
      ) {
        @if (businessForm.get("companyEmail")?.errors?.["required"]) {
          <span class="error-message">Email is required</span>
        }
        @if (businessForm.get("companyEmail")?.errors?.["email"]) {
          <span class="error-message">Please enter a valid email address</span>
        }
      }

      @if (activeDuplicateField === "companyEmail") {
        <ng-container
          *ngTemplateOutlet="duplicateResultsTemplate"
        ></ng-container>
      }
    </div>
    <div class="form-group">
      <label for="website">Website</label>
      <input
        id="website"
        type="url"
        formControlName="website"
        placeholder="https://example.com"
      />
      @if (
        businessForm.get("website")?.touched &&
        businessForm.get("website")?.errors?.["pattern"]
      ) {
        <span class="error-message"
          >Please enter a valid website URL (e.g., example.com or
          https://example.com)</span
        >
      }
    </div>
    <div class="form-group">
      <label for="businessType" class="required">Business Type</label>
      <select id="businessType" formControlName="businessType">
        <option value="">Select a business type</option>
        @for (option of businessTypeOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
        }
      </select>
      @if (
        businessForm.get("businessType")?.touched &&
        businessForm.get("businessType")?.invalid
      ) {
        <span class="error-message">Business type is required</span>
      }
    </div>
    <div class="form-group">
      <label for="yearFounded" class="required">Year Founded</label>
      <input
        id="yearFounded"
        type="date"
        formControlName="yearFounded"
        #yearFoundedInput
        [max]="todayDate"
        (click)="yearFoundedInput.showPicker()"
      />
      @if (
        businessForm.get("yearFounded")?.touched &&
        businessForm.get("yearFounded")?.invalid
      ) {
        @if (businessForm.get("yearFounded")?.errors?.["required"]) {
          <span class="error-message">Year founded is required</span>
        } @else if (businessForm.get("yearFounded")?.errors?.["futureDate"]) {
          <span class="error-message"
            >Year founded cannot be in the future</span
          >
        }
      }
    </div>
    <div class="form-group">
      <label for="numberOfEmployees" class="required"
        >Number of Employees</label
      >
      <input
        id="numberOfEmployees"
        type="text"
        formControlName="numberOfEmployees"
      />
      @if (
        businessForm.get("numberOfEmployees")?.touched &&
        businessForm.get("numberOfEmployees")?.invalid
      ) {
        @if (businessForm.get("numberOfEmployees")?.errors?.["required"]) {
          <span class="error-message">Number of employees is required</span>
        }
        @if (businessForm.get("numberOfEmployees")?.errors?.["invalidNumber"]) {
          <span class="error-message">Invalid number</span>
        }
        @if (businessForm.get("numberOfEmployees")?.errors?.["min"]) {
          <span class="error-message"
            >Number of employees cannot be less than 0.</span
          >
        }
        @if (businessForm.get("numberOfEmployees")?.errors?.["pattern"]) {
          <span class="error-message"
            >Number of employees must be a whole number</span
          >
        }
        @if (businessForm.get("numberOfEmployees")?.errors?.["maxDigits"]) {
          <span class="error-message">Must not exceed 10 digits</span>
        }
      }
    </div>
  </div>

  <div class="radio-groups">
    <div class="radio-group">
      <span class="group-label required">Preferred Language</span>
      <div class="radio-options">
        <div class="radio-item">
          <input
            id="preferredLanguageEnglish"
            type="radio"
            formControlName="preferredLanguage"
            value="english"
          />
          <label for="preferredLanguageEnglish">English</label>
        </div>
        <div class="radio-item">
          <input
            id="preferredLanguageSpanish"
            type="radio"
            formControlName="preferredLanguage"
            value="spanish"
          />
          <label for="preferredLanguageSpanish">Spanish</label>
        </div>
      </div>
      @if (
        businessForm.get("preferredLanguage")?.touched &&
        businessForm.get("preferredLanguage")?.invalid
      ) {
        <span class="error-message">Preferred language is required</span>
      }
    </div>
    <div class="radio-group">
      <span class="group-label required">Are you a US Military Veteran?</span>
      <div class="radio-options">
        <div class="radio-item">
          <input
            id="militaryVeteranYes"
            type="radio"
            formControlName="isMilitaryVeteran"
            [value]="true"
          />
          <label for="militaryVeteranYes">Yes</label>
        </div>
        <div class="radio-item">
          <input
            id="militaryVeteranNo"
            type="radio"
            formControlName="isMilitaryVeteran"
            [value]="false"
          />
          <label for="militaryVeteranNo">No</label>
        </div>
      </div>
      @if (
        businessForm.get("isMilitaryVeteran")?.touched &&
        businessForm.get("isMilitaryVeteran")?.invalid
      ) {
        <span class="error-message"
          >Please indicate if you are a US Military Veteran</span
        >
      }
    </div>
    <div class="radio-group">
      <span class="group-label required"
        >Are you the spouse of a US military veteran?</span
      >
      <div class="radio-options">
        <div class="radio-item">
          <input
            id="veteranSpouseYes"
            type="radio"
            formControlName="isVeteranSpouse"
            [value]="true"
          />
          <label for="veteranSpouseYes">Yes</label>
        </div>
        <div class="radio-item">
          <input
            id="veteranSpouseNo"
            type="radio"
            formControlName="isVeteranSpouse"
            [value]="false"
          />
          <label for="veteranSpouseNo">No</label>
        </div>
      </div>
      @if (
        businessForm.get("isVeteranSpouse")?.touched &&
        businessForm.get("isVeteranSpouse")?.invalid
      ) {
        <span class="error-message"
          >Please indicate if you are the spouse of a US military veteran.</span
        >
      }
    </div>
    <div class="radio-group">
      <span class="group-label">Minority Owned</span>
      <div class="radio-options">
        <div class="radio-item">
          <input
            id="minorityOwnedYes"
            type="radio"
            formControlName="isMinorityOwned"
            [value]="true"
          />
          <label for="minorityOwnedYes">Yes</label>
        </div>
        <div class="radio-item">
          <input
            id="minorityOwnedNo"
            type="radio"
            formControlName="isMinorityOwned"
            [value]="false"
          />
          <label for="minorityOwnedNo">No</label>
        </div>
      </div>
    </div>

    <div class="radio-group">
      <span class="group-label">Women Owned</span>
      <div class="radio-options">
        <div class="radio-item">
          <input
            id="womenOwnedYes"
            type="radio"
            formControlName="isWomenOwned"
            [value]="true"
          />
          <label for="womenOwnedYes">Yes</label>
        </div>
        <div class="radio-item">
          <input
            id="womenOwnedNo"
            type="radio"
            formControlName="isWomenOwned"
            [value]="false"
          />
          <label for="womenOwnedNo">No</label>
        </div>
      </div>
    </div>

    <div class="radio-group full-width">
      <span class="group-label required">Application Summary</span>
      <textarea
        id="applicationSummary"
        formControlName="applicationSummary"
        rows="4"
      ></textarea>
      @if (
        businessForm.get("applicationSummary")?.touched &&
        businessForm.get("applicationSummary")?.invalid
      ) {
        <span class="error-message">Application summary is required</span>
      }
    </div>

    <div class="radio-group full-width">
      <span class="group-label required"
        >What type of business support are you looking for? (Select all that
        apply)</span
      >
      <div class="checkbox-grid" formGroupName="businessSupportType">
        @for (type of businessSupportTypes; track type) {
          <div class="checkbox-item">
            <input
              [id]="'support_' + sanitizeKey(type)"
              type="checkbox"
              [formControlName]="sanitizeKey(type)"
            />
            <label [for]="'support_' + sanitizeKey(type)">{{ type }}</label>
          </div>
        }
      </div>
      @if (
        businessForm.get("businessSupportType")?.touched &&
        businessForm.get("businessSupportType")?.invalid
      ) {
        <span class="error-message"
          >Please select at least one business support type</span
        >
      }
    </div>

    <div class="radio-group">
      <span class="group-label required"
        >Are you interested in joining a local chamber of commerce or other
        regional business networking organizations?</span
      >
      <div class="radio-options">
        <div class="radio-item">
          <input
            id="chamberNetworkingYes"
            type="radio"
            formControlName="interestedInChamberOrBusinessNetworking"
            [value]="true"
          />
          <label for="chamberNetworkingYes">Yes</label>
        </div>
        <div class="radio-item">
          <input
            id="chamberNetworkingNo"
            type="radio"
            formControlName="interestedInChamberOrBusinessNetworking"
            [value]="false"
          />
          <label for="chamberNetworkingNo">No</label>
        </div>
      </div>
      @if (
        businessForm.get("interestedInChamberOrBusinessNetworking")?.touched &&
        businessForm.get("interestedInChamberOrBusinessNetworking")?.invalid
      ) {
        <span class="error-message"
          >Please indicate if you are interested in joining a chamber of
          commerce or business networking organizations</span
        >
      }
    </div>
  </div>
</form>

@if (selectedCompanyUniqueId) {
  <app-record-details
    [unique_id]="selectedCompanyUniqueId"
    (popupClosed)="closeCompanyDetails()"
  ></app-record-details>
}

<ng-template #duplicateResultsTemplate>
  @if (isSearchingDuplicates) {
    <div class="duplicate-search-loading">
      <span class="spinner"></span>
      <span>Checking for existing records...</span>
    </div>
  }

  @if (!isSearchingDuplicates && duplicateBusinesses.length > 0) {
    <div class="duplicate-businesses-card">
      <div class="duplicate-header">
        <div class="duplicate-title">
          <span
            >Matching Records Found ({{
              totalDuplicateCount || duplicateBusinesses.length
            }})</span
          >
        </div>
        <p class="duplicate-desc">
          Following records match the entered details (Business name, Email).
          Please review to avoid creating duplicate records.
        </p>
      </div>

      <div class="duplicate-list" (scroll)="onDuplicateListScroll($event)">
        @for (
          company of duplicateBusinesses;
          track company.unique_id || company.id || $index
        ) {
          <button
            type="button"
            class="duplicate-item"
            (click)="viewCompanyDetails(company, $event)"
          >
            <div class="item-main">
              <div class="item-header-row">
                <span class="item-name">{{ company.business_name }}</span>
                @if (
                  company.match_reasons && company.match_reasons.length > 0
                ) {
                  <div class="match-reasons">
                    @for (reason of company.match_reasons; track reason) {
                      <span class="reason-pill">{{
                        formatMatchReason(reason)
                      }}</span>
                    }
                  </div>
                }
              </div>
              <div class="item-details-row">
                @if (formatMatchAddress(company)) {
                  <span class="item-address">
                    <svg
                      class="location-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    {{ formatMatchAddress(company) }}
                  </span>
                }
                @if (company.email) {
                  <span class="item-meta">
                    <svg
                      class="meta-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                      ></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    {{ company.email }}
                  </span>
                }
                @if (company.phone) {
                  <span class="item-meta">
                    <svg
                      class="meta-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                      ></path>
                    </svg>
                    {{ company.phone }}
                  </span>
                }
              </div>
            </div>
            @if (
              company.source_type !== undefined && company.source_type !== null
            ) {
              <span
                class="source-badge"
                [class]="getSourceBadgeClass(company.source_type)"
              >
                {{ formatSourceLabel(company.source_type) }}
              </span>
            }
          </button>
        }

        @if (isLoadingMoreDuplicates) {
          <div class="duplicate-list-loading-more">
            <span class="spinner-small"></span>
            <span>Loading more matches...</span>
          </div>
        }
      </div>
    </div>
  }
</ng-template>
